import SunAccent from "@/components/feature/SunAccent";
import Reveal from "@/components/base/Reveal";
import { farmToPlateSteps } from "@/mocks/siteData";

export default function FarmToPlateSection() {
  return (
    <section id="farm-to-plate" className="sun-glaze bg-accent-50 py-20 md:py-28">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <Reveal className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-5">
              <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-500"></span>
              <span className="text-xs font-semibold tracking-[0.24em] uppercase text-accent-700">
                Farm to Plate
              </span>
            </div>
            <h2 className="font-heading text-3xl md:text-5xl leading-tight text-foreground-950 font-semibold">
              Know Your Food. Meet Your Farmer.
            </h2>
            <p className="mt-6 text-base md:text-lg text-foreground-700 leading-relaxed">
              The food on our plate has a journey. Rythugaru helps people experience this journey —
              taste seasonal produce, learn traditional recipes, participate in harvesting, share a
              meal with the farming community, and understand the work behind every meal.
            </p>

            <div className="flex flex-wrap items-center gap-x-2 gap-y-3 mt-9">
              {farmToPlateSteps.map((step, i) => (
                <div key={step} className="flex items-center gap-2">
                  <span className="bg-background-50 text-foreground-900 text-sm font-semibold px-4 py-2 rounded-full border border-accent-200">
                    {step}
                  </span>
                  {i < farmToPlateSteps.length - 1 && (
                    <i className="ri-arrow-right-s-line text-accent-500 text-lg"></i>
                  )}
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal className="lg:col-span-6" delay={120}>
            <div className="rounded-lg overflow-hidden w-full h-72 md:h-[26rem]">
              <img
                src="https://readdy.ai/api/search-image?query=Overhead%20shot%20of%20a%20traditional%20South%20Indian%20meal%20served%20on%20a%20banana%20leaf%20with%20fresh%20vegetables%2C%20rice%20and%20curries%2C%20surrounded%20by%20freshly%20harvested%20produce%20and%20clay%20pots%2C%20fresh%20natural%20light%2C%20rustic%20wooden%20table%2C%20painterly%20stylized%20earthy%20tones%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1200&height=900&seq=rythugaru-farm-to-plate-meal&orientation=landscape"
                width={1200}
                height={900}
                alt="Traditional South Indian farm-to-table meal served on a banana leaf"
                title="Farm to plate journey with Rythugaru"
                className="w-full h-full object-cover object-top"
                decoding="async"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}